import React, { useState } from 'react'
import { ServerRequestProtected } from '../../../../../utils/ServerDataRequest';
import { enumUtil } from '../../../../../utils/Enum';
import NotificationHandler from '../../../../../utils/NotificationHandler';
import { useSelector } from 'react-redux';

const useSuperSearchMultipleFunctions = (searchParam, setSearchParam, setOptions,controller, ApiLink, method, tableName, postBody, type) => {
    let PatientIDR = useSelector(state => state.Open_Patient_Tab?.find((pt) => pt.active === true))?.data?.id;
    const [isLoading, setIsLoading] = useState(false);

    const onSelect = (selectedDataArray, name) => {
        let modal = { ...searchParam };
        if ( selectedDataArray.length > 0) {
            const valueValues = selectedDataArray.map(data => data.value);
            modal[name] = valueValues.join(', ');
        } else {
            modal[name] = '';
        }
        setSearchParam(modal);
        // return selectedDataArray;
    }
    const fetchOptions = (searchTerm,abortController) => {
        console.log("fetchOptions",searchTerm, postBody)
            setIsLoading(true);
            ServerRequestProtected(controller + ApiLink, method, {
                "TableName": tableName,
                ...(tableName === "Encounter" ? { "ID": PatientIDR } : {}),
                ...(type === "Payment" || type === "Claim" || type === "PatientTask" ? {"SearchCriteria":searchTerm } : {"SearchParam":searchTerm }) ,
            }, abortController.signal
            ).then((response) => {
                setIsLoading(false);
                setOptions(response);
            }).catch((error) => {
                setOptions([]);
                setIsLoading(false);
            });
    }
    const SearchLetterHighlighted = ({ classes, text, searchValue, type }) => {
        if (!text || text?.length <= 0) return;
    
        const highlightText = (text, search) => {
            if (!search.trim()) return [text]; // Return original text as a single segment if search is empty
            // Escape special regex characters in the search string
            const escapedSearch = escapeRegExp(search);
            const regex = new RegExp(`(${escapedSearch})`, 'gi'); // Case-insensitive matching
                return text.split(regex).map((part, index) => regex.test(part) ? <span className='orange-clr' key={index}>{part}</span> : part)
        };
    
        const escapeRegExp = (string) => {
            return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special characters
        };
    
        const segments = highlightText(text, searchValue);
        return (
            <p className={classes} title={text}>
                {segments}
            </p>
        );
    }
    
  return { isLoading, onSelect, fetchOptions, SearchLetterHighlighted}
}

export default useSuperSearchMultipleFunctions